import React from 'react';
import styled from '@emotion/styled';
import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { Price } from '../../../../../shared/i18n/price/Price';
import { getFormattedPrice } from '../../../../../shared/i18n/price/utils/getFormattedPrice';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export const StyledGrandTotal = styled.h3`
	font-size: 20px;
	margin-top: 16px;
	display: flex;
	flex: 1;
`;

const StyledPrice = styled.span`
	margin-left: auto;
`;

interface IGrandTotalProps {
	totalPrice: IPrice;
	priceDifference?: IPrice;
}

export const GrandTotal = ({
	totalPrice,
	priceDifference,
}: IGrandTotalProps) => {
	const { t } = useTranslation();

	const totalDuePrice = priceDifference
		? new Price({
				currencyCode: priceDifference.currencyCode,
				centAmount: Math.max(priceDifference.centAmount, 0),
		  })
		: totalPrice;

	return (
		<StyledGrandTotal>
			{t('web_booking_summary_total_due')}
			<StyledPrice>{getFormattedPrice(totalDuePrice)}</StyledPrice>
		</StyledGrandTotal>
	);
};
